import script from "./CensusMaster.vue?vue&type=script&setup=true&lang=js"
export * from "./CensusMaster.vue?vue&type=script&setup=true&lang=js"

import "./CensusMaster.vue?vue&type=style&index=0&id=32c63311&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c63311"]])

export default __exports__